import { TenantMember, TenantMemberDisplayData } from '@kudos/http-client'

export const toRecognitionRecipient = (member: TenantMember): TenantMemberDisplayData => ({
  id: member.id,
  firstName: member.firstName,
  lastName: member.lastName,
  email: member.email ?? null,
  active: !member.suspendedAt && !member.deletedAt,
  avatarUrls: member.avatarUrls ?? null,
  jobTitle: member.publicStaffProfile?.jobTitle ?? '',
})
